export default "__VITE_ASSET__6ea72be2__"